import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ReceptaclesInPreconNotInPredesReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ReceptaclesInPreconNotInPredesReport;

ReceptaclesInPreconNotInPredesReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  changeTrafficMode: PropTypes.func,
};
